import React from 'react';

import { TimeLogsByWorker } from '@vyce/core/src/views/time/TimeLogsByWorker';

import { useTypedSelector } from '../../hooks';
import { ChatUser } from '@vyce/core/src/types';

export const EmployerTimeLogsByWorker: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { first_name, last_name, email, phone, photo, uuid } = useTypedSelector(state => state.user);

  const chatUser: ChatUser = {
    uid: uuid,
    name: `${first_name} ${last_name}`,
    email,
    phone,
    avatarUrl: photo?.url,
  };
  return <TimeLogsByWorker companyId={selectedCompany?.uuid} chatCreator={chatUser} />;
};
